import React, { Component, createRef } from 'react';
import { UsefullContactList, DirectoryFilters } from '.';
import { Collapse, AutoComplete } from '..';
import { UsefullContactService } from '../../Services';
import {
    IUsefullContact,
    IUsefullContactFilterParams,
    Dictionary,
    IPostalCode,
} from '../../Models';

interface IDirectoryUsefullContactListState {
    isDesktopFilterOpen: boolean;
    isMobileFilterOpen: boolean;
    usefullContactTitleList: string[];
    titleFilter: string; // FIX: controlled value
}

interface IDirectoryUsefullContactListProps {
    usefullContactList: IUsefullContact[];
    usefullContactFocus?: IUsefullContact;
    eAppointmentUrl: string;
    usefullContactFilterParams: IUsefullContactFilterParams;
    filterUsefullContactList: (p: IUsefullContactFilterParams) => void;
    fieldsOfSupportList: string[];
    usefullContactPartnerName: string;
    postalCodesList: (postalCodeParams?: string) => Promise<IPostalCode[]>;
    typesList: string[];
    radiusKilometers: Dictionary<number, string>[];
    postalCodeAndRadius: string;
    cancel: string;
    save: string;
    type: string;
    field: string;
    fieldOfSupport: string;
    language: string;
    takeAppointment: string;
    publicTransport: string;
    setBounce: (event: number) => void;
    stopBounce: (event: number) => void;
    postalCode: string;
    radius: string;
    dictRemoveFilter: string;
    dictNoResultTitle: string;
    dictNoResultDescription: string;
    dictUsefullContactName: string;
    dictSearch: string;
    dictSearchUsefullContact: string;
    isLoading: boolean;
    homepageUrl: string;
    usefullContactDetailPage: string;
    result: string;
    results: string;
    lang: string;
}

type TitleRefHandle = {
    handleClose?: () => void;
};

export class DirectoryUsefullContactList extends Component<
    IDirectoryUsefullContactListProps,
    IDirectoryUsefullContactListState
> {
    private titleRef = createRef<TitleRefHandle>();

    constructor(props: IDirectoryUsefullContactListProps) {
        super(props);

        this.state = {
            isDesktopFilterOpen: false,
            isMobileFilterOpen: false,
            usefullContactTitleList: [],
            titleFilter: '',
        };
    }

    componentDidMount() {
        void this.getUsefullContactTitleList();
    }

    componentDidUpdate(prevProps: IDirectoryUsefullContactListProps) {
        if (prevProps.postalCodesList !== this.props.postalCodesList) {
            // no-op but valid
        }
    }

    getUsefullContactTitleList = async () => {
        const list = await UsefullContactService.getAllUsefullContactTitle();
        this.setState({ usefullContactTitleList: list });
    };

    // ---------------------------
    // FILTER EVENTS
    // ---------------------------

    handleTitleModification = (userInput: string) => {
        this.setState({ titleFilter: userInput });
    };

    handleClickOnCompletion = (userInput: string) => {
        this.setState({ titleFilter: userInput });

        this.props.filterUsefullContactList({
            ...this.props.usefullContactFilterParams,
            title: userInput,
        });
    };

    handleOnSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        this.props.filterUsefullContactList({
            ...this.props.usefullContactFilterParams,
            title: this.state.titleFilter,
        });

        this.titleRef.current?.handleClose?.();
    };

    updateUsefullContactFilterParams = (
        params: IUsefullContactFilterParams
    ) => {
        this.props.filterUsefullContactList({
            ...params,
            title: this.props.usefullContactFilterParams.title,
        });
    };

    removeItem = (item: string) => {
        const updatedTypes = [...this.props.usefullContactFilterParams.type];
        const index = updatedTypes.indexOf(item);
        if (index !== -1) updatedTypes.splice(index, 1);

        this.updateUsefullContactFilterParams({
            ...this.props.usefullContactFilterParams,
            type: updatedTypes,
        });
    };

    togglePanel = () => {
        this.setState((prev) => ({
            isDesktopFilterOpen: !prev.isDesktopFilterOpen,
        }));
    };

    collapsePanel = () => {
        this.setState((prev) => ({
            isMobileFilterOpen: !prev.isMobileFilterOpen,
        }));
    };

    render() {
        return (
            <>
                <div className="map-details d-flex flex-column">
                    <header>
                        <div className="header-wrapper">
                            <div className="container-fluid px-0">
                                <div className="row">
                                    <div className="col-12">
                                        {this.props.usefullContactList.length >
                                            0 && (
                                            <span style={{ fontSize: '80%' }}>
                                                <strong>
                                                    {
                                                        this.props
                                                            .usefullContactList
                                                            .length
                                                    }
                                                </strong>{' '}
                                                {this.props.usefullContactList
                                                    .length > 1
                                                    ? this.props.results
                                                    : this.props.result}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-4 pr-lg-0">
                                        <form
                                            className="search-with-icon"
                                            onSubmit={this.handleOnSubmit}
                                            data-skip-captcha="true"
                                        >
                                            <div className="form-group">
                                                <div className="search autocomplete">
                                                    <AutoComplete
                                                        suggestions={
                                                            this.state
                                                                .usefullContactTitleList
                                                        }
                                                        filterName={
                                                            this
                                                                .handleTitleModification
                                                        }
                                                        search={
                                                            this.props
                                                                .dictSearchUsefullContact
                                                        }
                                                        clickOnCompletion={
                                                            this
                                                                .handleClickOnCompletion
                                                        }
                                                        userInput={
                                                            this.state
                                                                .titleFilter
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="d-lg-flex d-none col-lg-8 px-0">
                                        <div
                                            className="map-filter d-flex justify-content-center p-0 w-100 position-relative"
                                            style={{ top: 0, left: 0 }}
                                        >
                                            <DirectoryFilters
                                                filterUsefullContactList={
                                                    this
                                                        .updateUsefullContactFilterParams
                                                }
                                                fieldOfSupportList={
                                                    this.props
                                                        .fieldsOfSupportList
                                                }
                                                postalCodesList={
                                                    this.props.postalCodesList
                                                }
                                                typesList={this.props.typesList}
                                                usefullContactPartnerName={
                                                    this.props
                                                        .usefullContactPartnerName
                                                }
                                                radiusKilometers={
                                                    this.props.radiusKilometers
                                                }
                                                postalCodeAndRadius={
                                                    this.props
                                                        .postalCodeAndRadius
                                                }
                                                cancel={this.props.cancel}
                                                save={this.props.save}
                                                type={this.props.type}
                                                field={this.props.field}
                                                fieldOfSupport={
                                                    this.props.fieldOfSupport
                                                }
                                                language={this.props.language}
                                                postalCode={
                                                    this.props.postalCode
                                                }
                                                radius={this.props.radius}
                                                usefullContactFilterParams={
                                                    this.props
                                                        .usefullContactFilterParams
                                                }
                                                dictRemoveFilter={
                                                    this.props.dictRemoveFilter
                                                }
                                                dictUsefullContactName={
                                                    this.props
                                                        .dictUsefullContactName
                                                }
                                                dictSearch={
                                                    this.props.dictSearch
                                                }
                                                dictSearchUsefullContact={
                                                    this.props
                                                        .dictSearchUsefullContact
                                                }
                                            ></DirectoryFilters>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="d-lg-flex d-none col-lg-12 mt-4">
                                        <div className="chips">
                                            {this.props.usefullContactFilterParams.type.map(
                                                (item) => {
                                                    return (
                                                        <div
                                                            key={item}
                                                            className="d-inline-block border mr-2"
                                                            style={{
                                                                borderRadius:
                                                                    '8px',
                                                            }}
                                                        >
                                                            <span
                                                                className="chip m-0"
                                                                key={item}
                                                            >
                                                                {item}{' '}
                                                                <button
                                                                    aria-label="Annuler"
                                                                    className="btn-no-look"
                                                                    onClick={this.removeItem.bind(
                                                                        this,
                                                                        item
                                                                    )}
                                                                >
                                                                    <i className="icon-cross"></i>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-block d-lg-none align-right">
                            <a
                                href="#"
                                className={
                                    'btn-primary btn-filter' +
                                    (this.state.isMobileFilterOpen
                                        ? ' active'
                                        : '')
                                }
                                aria-expanded={this.state.isMobileFilterOpen}
                                aria-controls="filterSearchMobile"
                                data-target="#filterSearchMobile"
                                onClick={this.collapsePanel}
                            >
                                <i
                                    className={
                                        this.state.isMobileFilterOpen
                                            ? 'icon-cross'
                                            : 'icon-filtre'
                                    }
                                ></i>
                                {this.state.isMobileFilterOpen
                                    ? 'Masquer les filtres'
                                    : 'Afficher les filtres'}
                            </a>
                        </div>
                        <Collapse
                            id={'filterSearchMobile'}
                            active={this.state.isMobileFilterOpen}
                            desktop={true}
                        >
                            <div
                                id="filterSearch"
                                className="d-block d-lg-none"
                            >
                                <div className="map-filter d-block d-lg-none">
                                    <DirectoryFilters
                                        filterUsefullContactList={
                                            this
                                                .updateUsefullContactFilterParams
                                        }
                                        fieldOfSupportList={
                                            this.props.fieldsOfSupportList
                                        }
                                        postalCodesList={
                                            this.props.postalCodesList
                                        }
                                        typesList={this.props.typesList}
                                        usefullContactPartnerName={
                                            this.props.usefullContactPartnerName
                                        }
                                        radiusKilometers={
                                            this.props.radiusKilometers
                                        }
                                        postalCodeAndRadius={
                                            this.props.postalCodeAndRadius
                                        }
                                        cancel={this.props.cancel}
                                        save={this.props.save}
                                        type={this.props.type}
                                        field={this.props.field}
                                        fieldOfSupport={
                                            this.props.fieldOfSupport
                                        }
                                        language={this.props.language}
                                        postalCode={this.props.postalCode}
                                        radius={this.props.radius}
                                        usefullContactFilterParams={
                                            this.props
                                                .usefullContactFilterParams
                                        }
                                        dictRemoveFilter={
                                            this.props.dictRemoveFilter
                                        }
                                        dictUsefullContactName={
                                            this.props.dictUsefullContactName
                                        }
                                        dictSearch={this.props.dictSearch}
                                        dictSearchUsefullContact={
                                            this.props.dictSearchUsefullContact
                                        }
                                    ></DirectoryFilters>
                                </div>
                            </div>
                        </Collapse>
                    </header>
                    {this.props.isLoading && (
                        <div className="lds-ripple">
                            <div></div>
                            <div></div>
                        </div>
                    )}
                    {this.props.usefullContactList.length == 0 &&
                        !this.props.isLoading && (
                            <div className="empty-state">
                                <i className="icon-no-results"></i>
                                <p>
                                    <b>{this.props.dictNoResultTitle}</b>
                                </p>
                                <p>{this.props.dictNoResultDescription}</p>
                            </div>
                        )}
                    <div className="map-tiles flex-grow-1">
                        <UsefullContactList
                            usefullContactList={this.props.usefullContactList}
                            eAppointmentUrl={this.props.eAppointmentUrl}
                            takeAppointment={this.props.takeAppointment}
                            publicTransport={this.props.publicTransport}
                            setBounce={this.props.setBounce}
                            stopBounce={this.props.stopBounce}
                            homepageUrl={this.props.homepageUrl}
                            usefullContactDetailPage={
                                this.props.usefullContactDetailPage
                            }
                            lang={this.props.lang}
                        ></UsefullContactList>
                    </div>
                </div>
            </>
        );
    }
}
